/// <amd-module name="Artifacts/Nuget/commands/Download" />
import { NugetActions } from "Artifacts/Nuget/redux";
import { getDownloadCommandCreator } from "Artifacts/Root/protocols/Commands";

export const createDownloadCommand = getDownloadCommandCreator(NugetActions.download);
